// @ts-nocheck
import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';

import {
  useLazyGetEmployeesByTeamQuery,
  usePatchProjectMutation,
} from '@greenkub-fronts/data-access';
import {
  AppDispatch,
  GROUP_NAME,
  Project,
  User,
} from '@greenkub-fronts/shared/interface';
import {
  addErrorMessage,
  addPositiveMessage,
} from '@greenkub-fronts/domain/snackbar';

import styles from './employees-modal.module.scss';
import { Modal, GKSelect, Button, BtnLevel, Icon, IconEnum } from '../..';

export interface EmployeesModalProps {
  project: Project;
  isOpen: boolean;
  onChangeIsOpen: Function;
}

const EmployeesModal = (props: EmployeesModalProps) => {
  const { project, isOpen, onChangeIsOpen } = props;
  const dispatch = useDispatch<AppDispatch>();

  const { reset } = useForm();

  const [patchProject] = usePatchProjectMutation();

  const [getEmployeesByTeam] = useLazyGetEmployeesByTeamQuery();

  const [salesUser, setSalesUser] = useState<string>();
  const [salesUserName, setSalesUserName] = useState<string>();
  const [salesList, setSalesList] = useState<
    { value: string; label: string }[]
  >([]);

  const [urbanismeUser, setUrbanismeUser] = useState<string>();
  const [urbanismeUserName, setUrbanismeUserName] = useState<string>();
  const [urbanismeList, setUrbanismeList] = useState<
    { value: string; label: string }[]
  >([]);

  const [serviceClientUser, setServiceClientUser] = useState<string>();
  const [serviceClientUserName, setServiceClientUserName] =
    useState<string>('');
  const [serviceClientList, setServiceClientList] = useState<
    { value: string; label: string }[]
  >([]);

  const [conducteurTvxUser, setConducteurTvxUser] = useState<string>();
  const [conducteurTvxUserName, setConducteurTvxUserName] =
    useState<string>('');
  const [conducteurTvxList, setConducteurTvxList] = useState<
    { value: string; label: string }[]
  >([]);

  const [financeUser, setFinanceUser] = useState<string>();
  const [financeUserName, setFinanceUserName] = useState<string>();
  const [financeList, setFinanceList] = useState<
    { value: string; label: string }[]
  >([]);

  const [installateursUser, setInstallateursUser] = useState<string>();
  const [installateursUserName, setInstallateursUserName] = useState<string>();
  const [installateursList, setInstallateursList] = useState<
    { value: string; label: string }[]
  >([]);

  const [currentTeam, setCurrentTeam] = useState<string>();
  const [currentUserId, setCurrentUserId] = useState<string>('');

  useEffect(() => {
    const fetchAPI = async () => {
      const sales = project.sales;
      const urba = project.urba;
      const serviceClient = project.serviceClient;
      const conducteurTvx = project.conducteurTvx;
      const finance = project.finance;
      const installateurs = project.installateurs;

      if (sales) setSalesUser(sales.id);
      if (urba) setUrbanismeUser(urba.id);
      if (serviceClient) setServiceClientUser(serviceClient.id);
      if (conducteurTvx) setConducteurTvxUser(conducteurTvx.id);
      if (finance) setFinanceUser(finance.id);
      if (installateurs) setInstallateursUser(installateurs.id);

      if (sales) setSalesUserName(sales.firstName + ' ' + sales.lastName);
      if (urba) setUrbanismeUserName(urba.firstName + ' ' + urba.lastName);
      if (serviceClient)
        setServiceClientUserName(
          serviceClient.firstName + ' ' + serviceClient.lastName
        );
      if (conducteurTvx)
        setConducteurTvxUserName(
          conducteurTvx.firstName + ' ' + conducteurTvx.lastName
        );
      if (finance)
        setFinanceUserName(finance.firstName + ' ' + finance.lastName);
      if (installateurs)
        setInstallateursUserName(
          installateurs.firstName + ' ' + installateurs.lastName
        );

      // get list of employees by team
      getEmployeesByTeam({
        team: 'Sales',
        groupName: GROUP_NAME.EMPLOYEE_MODAL,
      }).then((resp) => {
        const employees: { value: string; label: string }[] = [];
        resp.data.map((user: User) => {
          employees.push({
            value: user.id,
            label: user.firstName + ' ' + user.lastName,
          });
        });
        setSalesList(employees);
      });
      getEmployeesByTeam({
        team: 'Urbanisme',
        groupName: GROUP_NAME.EMPLOYEE_MODAL,
      }).then((resp) => {
        const employees: { value: string; label: string }[] = [];
        resp.data.map((user: User) => {
          employees.push({
            value: user.id,
            label: user.firstName + ' ' + user.lastName,
          });
        });
        setUrbanismeList(employees);
      });
      getEmployeesByTeam({
        team: 'Service Clients',
        groupName: GROUP_NAME.EMPLOYEE_MODAL,
      }).then((resp) => {
        const employees: { value: string; label: string }[] = [];
        resp.data.map((user: User) => {
          employees.push({
            value: user.id,
            label: user.firstName + ' ' + user.lastName,
          });
        });
        setServiceClientList(employees);
      });
      getEmployeesByTeam({
        team: 'Conducteur de tvx',
        groupName: GROUP_NAME.EMPLOYEE_MODAL,
      }).then((resp) => {
        const employees: { value: string; label: string }[] = [];
        resp.data.map((user: User) => {
          employees.push({
            value: user.id,
            label: user.firstName + ' ' + user.lastName,
          });
        });
        setConducteurTvxList(employees);
      });
      getEmployeesByTeam({
        team: 'Finance',
        groupName: GROUP_NAME.EMPLOYEE_MODAL,
      }).then((resp) => {
        const employees: { value: string; label: string }[] = [];
        resp.data.map((user: User) => {
          employees.push({
            value: user.id,
            label: user.firstName + ' ' + user.lastName,
          });
        });
        setFinanceList(employees);
      });
      getEmployeesByTeam({
        team: 'Installateurs Interne',
        groupName: GROUP_NAME.EMPLOYEE_MODAL,
      }).then((respInt) => {
        getEmployeesByTeam({
          team: 'Installateurs Externe',
          groupName: GROUP_NAME.EMPLOYEE_MODAL,
        }).then((respExt) => {
          const employees: { value: string; label: string }[] = [];
          respInt.data.map((user: User) => {
            employees.push({
              value: user.id,
              label: user.firstName + ' ' + user.lastName,
            });
          });
          respExt.data.map((user: User) => {
            employees.push({
              value: user.id,
              label: user.firstName + ' ' + user.lastName,
            });
          });
          setInstallateursList(employees);
        });
      });
    };
    if (project) {
      fetchAPI();
    }
  }, []);

  const validateUpdate = () => {
    const body: any = {};

    if (salesUser) {
      body.sales = salesUser;
    }
    if (urbanismeUser) {
      body.urba = urbanismeUser;
    }
    if (serviceClientUser) {
      body.serviceClient = serviceClientUser;
    }
    if (conducteurTvxUser) {
      body.conducteurTvx = conducteurTvxUser;
    }
    if (financeUser) {
      body.finance = financeUser;
    }
    if (installateursUser) {
      body.installateurs = installateursUser;
    }

    changeTeam('');
    patchProject({ projectId: project.id, project: body }).then((resp: any) => {
      if (resp.error) {
        dispatch(addErrorMessage(resp.error));
      } else {
        dispatch(addPositiveMessage(resp.data));
      }
    });
  };

  const getCurrentUserId = (team: string) => {
    switch (team) {
      case 'Sales':
        if (salesUser) setCurrentUserId(salesUser);
        break;
      case 'Urbanisme':
        if (urbanismeUser) setCurrentUserId(urbanismeUser);
        break;
      case 'Service Clients':
        if (serviceClientUser) setCurrentUserId(serviceClientUser);
        break;
      case 'ConducteurTvx':
        if (conducteurTvxUser) setCurrentUserId(conducteurTvxUser);
        break;
      case 'Finance':
        if (financeUser) setCurrentUserId(financeUser);
        break;
      case 'Installateurs':
        if (installateursUser) setCurrentUserId(installateursUser);
        break;
    }
  };

  const changeTeam = (team: string) => {
    setCurrentTeam(team);
  };

  const changeUser = (team: string, id: string) => {
    switch (team) {
      case 'Sales':
        salesList.map((user, idx) => {
          if (user.value === id) {
            setSalesUserName(user.label);
          }
        });
        setSalesUser(id);
        reset({ salesUser: id });
        break;
      case 'Urbanisme':
        urbanismeList.map((user, idx) => {
          if (user.value === id) {
            setUrbanismeUserName(user.label);
          }
        });
        setUrbanismeUser(id);
        reset({ urbanismeUser: id });
        break;
      case 'Service Clients':
        serviceClientList.map((user, idx) => {
          if (user.value === id) {
            setServiceClientUserName(user.label);
          }
        });
        setServiceClientUser(id);
        reset({ serviceClientUser: id });
        break;
      case 'ConducteurTvx':
        conducteurTvxList.map((user, idx) => {
          if (user.value === id) {
            setConducteurTvxUserName(user.label);
          }
        });
        setConducteurTvxUser(id);
        reset({ conducteurTvxUser: id });
        break;
      case 'Finance':
        financeList.map((user, idx) => {
          if (user.value === id) {
            setFinanceUserName(user.label);
          }
        });
        setFinanceUser(id);
        reset({ financeUser: id });
        break;
      case 'Installateurs':
        installateursList.map((user, idx) => {
          if (user.value === id) {
            setInstallateursUserName(user.label);
          }
        });
        setInstallateursUser(id);
        reset({ controleUser: id });
        break;
    }
  };

  return (
    <Modal
      className={styles['EmployeesModal']}
      isOpened={isOpen}
      onCloseModal={() => {
        onChangeIsOpen(false);
      }}
      hasCloseBtn={true}
    >
      {project && (
        <div className={styles['GK-modal']}>
          <h3>Modifier les employés en charge du projet</h3>
          <ul>
            <li>
              <p className={styles['EmployeesModal-team']}>Sales</p>
              {currentTeam === 'Sales' ? (
                <React.Fragment>
                  <GKSelect
                    name="salesUser"
                    placeholder="Sales en charge"
                    // control={control}
                    options={salesList}
                    defaultValue={salesUser}
                    customOnChange={(value: string) => {
                      changeUser('Sales', value);
                    }}
                  />
                  <Icon
                    name={IconEnum.CHECK}
                    onClick={() => {
                      changeTeam('');
                    }}
                  />
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <p
                    onClick={() => {
                      changeTeam('Sales');
                    }}
                    className={styles['EmployeesModal-current']}
                  >
                    {salesUserName ? (
                      <b>{salesUserName}</b>
                    ) : (
                      <span>Aucun employé selectionné</span>
                    )}
                  </p>
                  <Icon
                    name={IconEnum.CHANGE_USER}
                    onClick={() => {
                      changeTeam('Sales');
                    }}
                  />
                </React.Fragment>
              )}
            </li>
            <li>
              <p className={styles['EmployeesModal-team']}>Urbanisme</p>
              {currentTeam === 'Urbanisme' ? (
                <React.Fragment>
                  <GKSelect
                    name="urbanismeUser"
                    placeholder="Urba en charge"
                    // control={control}
                    options={urbanismeList}
                    defaultValue={urbanismeUser}
                    customOnChange={(value: string) => {
                      changeUser('Urbanisme', value);
                    }}
                  />
                  <Icon
                    name={IconEnum.CHECK}
                    onClick={() => {
                      changeTeam('');
                    }}
                  />
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <p
                    onClick={() => {
                      changeTeam('Urbanisme');
                    }}
                    className={styles['EmployeesModal-current']}
                  >
                    {urbanismeUserName ? (
                      <b>{urbanismeUserName}</b>
                    ) : (
                      <span>Aucun employé selectionné</span>
                    )}
                  </p>
                  <Icon
                    name={IconEnum.CHANGE_USER}
                    onClick={() => {
                      changeTeam('Urbanisme');
                    }}
                  />
                </React.Fragment>
              )}
            </li>
            <li>
              <p className={styles['EmployeesModal-team']}>Service Clients</p>
              {currentTeam === 'Service Clients' ? (
                <React.Fragment>
                  <GKSelect
                    name="serviceClientUser"
                    placeholder="Service Client en charge"
                    // control={control}
                    options={serviceClientList}
                    defaultValue={serviceClientUser}
                    customOnChange={(value: string) => {
                      changeUser('Service Clients', value);
                    }}
                  />
                  <Icon
                    name={IconEnum.CHECK}
                    onClick={() => {
                      changeTeam('');
                    }}
                  />
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <p
                    onClick={() => {
                      changeTeam('Service Clients');
                    }}
                    className={styles['EmployeesModal-current']}
                  >
                    {serviceClientUserName ? (
                      <b>{serviceClientUserName}</b>
                    ) : (
                      <span>Aucun employé selectionné</span>
                    )}
                  </p>
                  <Icon
                    name={IconEnum.CHANGE_USER}
                    onClick={() => {
                      changeTeam('Service Clients');
                    }}
                  />
                </React.Fragment>
              )}
            </li>
            <li>
              <p className={styles['EmployeesModal-team']}>
                Conducteur De Travaux
              </p>
              {currentTeam === 'ConducteurTvx' ? (
                <React.Fragment>
                  <GKSelect
                    name="conducteurTvxUser"
                    placeholder="Conducteur de travaux"
                    // control={control}
                    options={conducteurTvxList}
                    defaultValue={conducteurTvxUser}
                    customOnChange={(value: string) => {
                      changeUser('ConducteurTvx', value);
                    }}
                  />
                  <Icon
                    name={IconEnum.CHECK}
                    onClick={() => {
                      changeTeam('');
                    }}
                  />
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <p
                    onClick={() => {
                      changeTeam('ConducteurTvx');
                    }}
                    className={styles['EmployeesModal-current']}
                  >
                    {conducteurTvxUserName ? (
                      <b>{conducteurTvxUserName}</b>
                    ) : (
                      <span>Aucun employé selectionné</span>
                    )}
                  </p>
                  <Icon
                    name={IconEnum.CHANGE_USER}
                    onClick={() => {
                      changeTeam('ConducteurTvx');
                    }}
                  />
                </React.Fragment>
              )}
            </li>
            <li>
              <p className={styles['EmployeesModal-team']}>Finance</p>
              {currentTeam === 'Finance' ? (
                <React.Fragment>
                  <GKSelect
                    name="financeUser"
                    placeholder="Finance"
                    // control={control}
                    options={financeList}
                    defaultValue={financeUser}
                    customOnChange={(value: string) => {
                      changeUser('Finance', value);
                    }}
                  />
                  <Icon
                    name={IconEnum.CHECK}
                    onClick={() => {
                      changeTeam('');
                    }}
                  />
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <p
                    onClick={() => {
                      changeTeam('Finance');
                    }}
                    className={styles['EmployeesModal-current']}
                  >
                    {financeUserName ? (
                      <b>{financeUserName}</b>
                    ) : (
                      <span>Aucun employé selectionné</span>
                    )}
                  </p>
                  <Icon
                    name={IconEnum.CHANGE_USER}
                    onClick={() => {
                      changeTeam('Finance');
                    }}
                  />
                </React.Fragment>
              )}
            </li>
            <li>
              <p className={styles['EmployeesModal-team']}>Installateurs</p>
              {currentTeam === 'Installateurs' ? (
                <React.Fragment>
                  <GKSelect
                    name="installateursUser"
                    placeholder="Installateurs"
                    // control={control}
                    options={installateursList}
                    defaultValue={installateursUser}
                    customOnChange={(value: string) => {
                      changeUser('Installateurs', value);
                    }}
                  />
                  <Icon
                    name={IconEnum.CHECK}
                    onClick={() => {
                      changeTeam('');
                    }}
                  />
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <p
                    onClick={() => {
                      changeTeam('Installateurs');
                    }}
                    className={styles['EmployeesModal-current']}
                  >
                    {installateursUserName ? (
                      <b>{installateursUserName}</b>
                    ) : (
                      <span>Aucun employé selectionné</span>
                    )}
                  </p>
                  <Icon
                    name={IconEnum.CHANGE_USER}
                    onClick={() => {
                      changeTeam('Installateurs');
                    }}
                  />
                </React.Fragment>
              )}
            </li>
          </ul>
          <Button
            onClick={(e) => validateUpdate()}
            level={BtnLevel.SECONDARY}
            label="Confirmation"
          />
        </div>
      )}
    </Modal>
  );
};

export default EmployeesModal;
